/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WpisTo } from '../../models/wpis-to';

export interface ApiWebFaqKategorieGet$Params {
}

export function apiWebFaqKategorieGet(http: HttpClient, rootUrl: string, params?: ApiWebFaqKategorieGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WpisTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebFaqKategorieGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WpisTo>>;
    })
  );
}

apiWebFaqKategorieGet.PATH = '/api/web/faq/kategorie';
